'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  theme: _propTypes2.default.object
};

/** PROP RECEIVERS */
var spacingProps = function spacingProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var marginRight = (0, _reactackleCore.getValueString)(theme.reactackle.components.textfield.label.labelTooltipSpacing);

  return 'margin-right: ' + marginRight + ';';
};
var paddingBottom = 1; // To be sure that font descenders aren't cut

/** STYLES */
var LabelTextStyled = exports.LabelTextStyled = _styledComponents2.default.div.withConfig({
  displayName: 'LabelTextStyled'
})(['overflow:hidden;text-overflow:ellipsis;padding-bottom:', 'px;', ';'], paddingBottom, spacingProps);

LabelTextStyled.propTypes = propTypes;
LabelTextStyled.displayName = 'LabelTextStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text-field/dist/styles/LabelTextStyled.js
// module id = 844
// module chunks = 0